import { render, staticRenderFns } from "./App.vue?vue&type=template&id=f8efae96&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=f8efae96&prod&lang=scss&vars=%7B%20finnalFontFamily%20%7D"
import style1 from "./App.vue?vue&type=style&index=1&id=f8efae96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8efae96",
  null
  
)

export default component.exports